const tag = '[Manager] '

export default class ManagerActions {
  // Action types
  static UPDATE_ERROR = `${tag} UPDATE_ERROR`
  static INCREMENT_LOADER = `${tag} INCREMENT_LOADER`
  static DECREMENT_LOADER = `${tag} DECREMENT_LOADER`
  static RESET_LOADER = `${tag} RESET_LOADER`

  // Action creators
  static updateError = (payload) => ({ payload, type: ManagerActions.UPDATE_ERROR })
  static incrementLoader = () => ({ type: ManagerActions.INCREMENT_LOADER })
  static decrementLoader = () => ({ type: ManagerActions.DECREMENT_LOADER })
  static resetLoader = () => ({ type: ManagerActions.RESET_LOADER })
}
